/**
 * Security type enumeration
 */
export enum SecurityType {
  Stock = 'stock',
  Bond = 'bond',
  ETF = 'etf',
  MoneyMarketFund = 'money_market_fund',
  LongCall = 'long_call',
  LongPut = 'long_put',
  ShortCall = 'short_call',
  ShortPut = 'short_put',
  Option = 'option',  // Generic option type when call/put or long/short is unknown
  REIT = 'reit',
  MutualFund = 'mutual_fund',
  Cash = 'cash',      // Cash balances, interest on cash, cash sweeps
  Crypto = 'crypto',  // Cryptocurrency
  Unknown = 'unknown',
}

/**
 * Check if security type is an option
 */
export function isOptionSecurityType(securityType: SecurityType): boolean {
  return [
    SecurityType.LongCall,
    SecurityType.LongPut,
    SecurityType.ShortCall,
    SecurityType.ShortPut,
    SecurityType.Option,
  ].includes(securityType);
}

/**
 * Check if security type is equity (stocks, ETFs, mutual funds)
 */
export function isEquitySecurityType(securityType: SecurityType): boolean {
  return [
    SecurityType.Stock,
    SecurityType.ETF,
    SecurityType.MutualFund,
    SecurityType.REIT,
  ].includes(securityType);
}

/**
 * Check if security type is fixed income
 */
export function isFixedIncomeSecurityType(securityType: SecurityType): boolean {
  return [
    SecurityType.Bond,
    SecurityType.MoneyMarketFund,
  ].includes(securityType);
}
